import React from "react";
import { CalendarHeart } from "lucide-react";
import { useLang } from "@/context/LangContext";

// Estimated Sri Lankan pension paydays (last working day of each month).
const PAYDAYS = [
  "2026-10-30", "2026-11-30", "2026-12-31",
  "2027-01-29", "2027-02-26", "2027-03-31", "2027-04-30", "2027-05-31",
  "2027-06-30", "2027-07-30", "2027-08-31", "2027-09-30",
  "2027-10-29", "2027-11-30", "2027-12-31",
];

const LB = {
  title: { si: "ලබන විශ්‍රාම වැටුප් දිනය", en: "Next pension payday", ta: "அடுத்த ஓய்வூதிய நாள்" },
  today: { si: "අදයි! 🌸", en: "It's today! 🌸", ta: "இன்றே! 🌸" },
  in_days: { si: "තව දින {n}kින්", en: "in {n} days", ta: "இன்னும் {n} நாட்களில்" },
  tomorrow: { si: "හෙට!", en: "Tomorrow!", ta: "நாளை!" },
  reminder: {
    si: "පළමුව බෙහෙත් හා ආහාර සඳහා වෙන් කරගන්න 🪔",
    en: "Set aside medicine & food first 🪔",
    ta: "முதலில் மருந்து & உணவுக்கு ஒதுக்குங்கள் 🪔",
  },
};

const MONTHS = {
  si: ["ජනවාරි", "පෙබරවාරි", "මාර්තු", "අප්‍රේල්", "මැයි", "ජූනි", "ජූලි", "අගෝස්තු", "සැප්තැම්බර්", "ඔක්තෝබර්", "නොවැම්බර්", "දෙසැම්බර්"],
  en: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  ta: ["ஜனவரி", "பிப்ரவரி", "மார்ச்", "ஏப்ரல்", "மே", "ஜூன்", "ஜூலை", "ஆகஸ்ட்", "செப்டம்பர்", "அக்டோபர்", "நவம்பர்", "டிசம்பர்"],
};

export const PensionPayday = () => {
  const { lang, fontClass } = useLang();
  const L = (k) => (LB[k] && (LB[k][lang] || LB[k].en)) || k;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const next = PAYDAYS.map((d) => new Date(`${d}T00:00:00`)).find((d) => d >= today);
  if (!next) return null;

  const days = Math.round((next - today) / 86400000);
  const months = MONTHS[lang] || MONTHS.en;
  const dateLabel = `${next.getDate()} ${months[next.getMonth()]} ${next.getFullYear()}`;
  const when = days === 0 ? L("today") : days === 1 ? L("tomorrow") : L("in_days").replace("{n}", days);

  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 mt-4" data-testid="pension-payday">
      <div className="rounded-3xl p-5 flex items-center gap-4" style={{ background: "var(--card)", border: "2px solid var(--border)" }}>
        <span className="grid place-items-center w-14 h-14 rounded-2xl shrink-0" style={{ background: "var(--brass-light)", color: "var(--accent)" }}>
          <CalendarHeart size={26} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="font-ui text-xs font-bold uppercase tracking-wide" style={{ color: "var(--accent)" }}>{L("title")}</p>
          <p className={`${fontClass()} text-lg font-bold leading-tight`} style={{ color: "var(--text)" }} data-testid="pension-payday-date">
            {dateLabel} <span className="font-ui text-sm font-semibold" style={{ color: "var(--text-2)" }}>· {when}</span>
          </p>
          <p className="font-ui text-xs mt-1" style={{ color: "var(--text-muted)" }}>{L("reminder")}</p>
        </div>
      </div>
    </section>
  );
};
